unit NetType;
{

/* Initail. */

}
interface

uses
  JS, SysUtils,
  DepartmentItemListType, FileType, NetNumberItemListType, TemperatureType, UserType, WeightScaleType;

type
  TNetType = class
  private
    fNetKey: String;
    fName: String;
    fInfo: String;
    fAmountActive: Word;
    fAmountNotActive: Word;
    fNetNumberItemList: TNetNumberItemListType;
    fDepartmentItemList: TDepartmentItemListType;
    fWeightScale: TWeightScaleType;
    fTemperature: TTemperatureType;
    fPicture: TFileType;
    fCreationDate: String;
    fCreatedBy: TUserType;
    fChangedDate: String;
    fChangedBy: TUserType;
    fActive: Boolean;
  public
    property NetKey: String read fNetKey;
    property Name: String read fName;
    property Info: String read fInfo;
    property AmountActive: Word read fAmountActive;
    property AmountNotActive: Word read fAmountNotActive;
    property NetNumberItemList: TNetNumberItemListType read fNetNumberItemList;
    property DepartmentItemList: TDepartmentItemListType read fDepartmentItemList;
    property WeightScale: TWeightScaleType read fWeightScale;
    property Temperature: TTemperatureType read fTemperature;
    property Picture: TFileType read fPicture;
    property CreationDate: String read fCreationDate;
    property CreatedBy: TUserType read fCreatedBy;
    property ChangedDate: String read fChangedDate;
    property ChangedBy: TUserType read fChangedBy;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TNetType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fNetKey := String(JSObject_Type['netKey']);
    fName := String(JSObject_Type['name']);
    fInfo := String(JSObject_Type['info']);
    fAmountActive := StrToIntDef(String(JSObject_Type['amountActive']), 0);
    fAmountNotActive := StrToIntDef(String(JSObject_Type['amountNotActive']), 0);
    fNetNumberItemList := TNetNumberItemListType.Create(TJSJSON.stringify(JSObject_Type['netNumberItemList']));
    fDepartmentItemList := TDepartmentItemListType.Create(TJSJSON.stringify(JSObject_Type['departmentItemList']));
    fWeightScale := TWeightScaleType.Create(TJSJSON.stringify(JSObject_Type['weightScale']));
    fTemperature := TTemperatureType.Create(TJSJSON.stringify(JSObject_Type['temperature']));
    fPicture := TFileType.Create(TJSJSON.stringify(JSObject_Type['picture']));
    fCreationDate := String(JSObject_Type['creationDate']);
    fCreatedBy := TUserType.Create(TJSJSON.stringify(JSObject_Type['createdBy']));
    fChangedDate := String(JSObject_Type['changedDate']);
    fChangedBy := TUserType.Create(TJSJSON.stringify(JSObject_Type['changedBy']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
